import i18n from '../../../../../../i18n'
import { DecryptedPropertyStub } from '@icure/cardinal-sdk'

export const emailSubject = i18n.t('emails.consultation.subject')
export const emailHtml = (firstName: string, lastName: string) => {
  // Use localized template (HTML) from i18n and replace placeholders
  const template = i18n.t('emails.consultation.bodyHtml', { firstName, lastName })
  return template
}

export const getPropertyStringValue = (properties: DecryptedPropertyStub[] | undefined, identifier: string) => {
  if (properties === undefined) return undefined
  const res = properties.find((prop) => prop.type?.identifier === identifier)
  return res?.typedValue?.stringValue
}
